import type { FaireProductEntity } from "../../entity_types/product";

export const p_47gzd6rwfe: FaireProductEntity = {
  token: "p_47gzd6rwfe",
  type: "product",
  name: "Deco Hoops",
  brandToken: "b_5pnnp7uhbd",
  brandName: "Lila Rice",
  imageUrl:
    "https://cdn.faire.com/fastly/47dc83ff1a68d429974c7e3bf770532bf61d732b4a9ade6089d3e09f2a457bb8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f120ad3923de2159a9d167ec2066a6f734b3ca94ff72f4f81e2c3edc4738f42.jpeg",
    "https://cdn.faire.com/fastly/5d0a426a8867b13370bdf388f17b6cb728cf2f8c8b578df2270e08de059bae41.jpeg",
    "https://cdn.faire.com/fastly/9f03bcfbe2b3bab8d481f7c4fcc43fc6ac1ba7ae0869fa62ea422918bb8940b9.png",
  ],
  priceDollars: 37,
  description:
    'A longtime favorite. Simple, lightweight earrings that are a hybrid between a hoop and a hook-style earring. Available in small (1"), medium (1.75" long) and large (2.5" long) in silver or 14k goldfill. Gently hammered to catch the light. Small size now available in 14k gold. Ships in 5-10 business days. Handmade in Brooklyn.',
  tags: [],
  msrpDollars: 74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:22.706Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
